export default {
  methods: {
    verifySSN({ target }) {
        // Allow an override
        if (this.assignment.loanout_status > 0 && ( target.value == 0 || target.value.toLowerCase() === 'na' )) {
            this.employee[target.name] = 'NA';
            this.errors[target.name] = false;
            // this.changed[target.name] = true;
            return true;
        }

        if (parseInt(this.assignment.country_id) === 1) {
            // US
            let digits = target.value.replace (/[^0-9]/g,'');
            if (digits.length === 9) {
                // correct
                this.employee[target.name] = digits.substr(0,3) + '-' + digits.substr(3,2) + '-' + digits.substr(5,4);
                this.errors[target.name] = false;
                // this.changed[target.name] = true;
                return true;
            } else {
                this.errors[target.name] = true;
                return false;
            }
        } else if (this.isCanada) {
            // Canada
            let digits = target.value.replace (/[^0-9]/g,'');
            // basic validation. 9 ditis
            if (digits.length === 9) {
                // Luhn algorithm will be applied except admin user
                if (!this.adminAccess) {
                    let total = 0;
                    for (let i=1; i<digits.length+1; i++) {
                        if (i%2 === 0) {
                            let temp = parseInt(digits[i-1]) * 2;
                            total += parseInt((temp/10)) + parseInt((temp%10));
                        } else {
                            total += parseInt(digits[i-1]);
                        }
                    }
                    if ( (total % 10) != 0) {
                        this.createDialog({ "title": "Warning", "body": 'The Social Insurance Number entered is not valid. Please review and update.', "buttonNo": false, "buttonYesLabel": "OK" });
                        this.errors[target.name] = true;
                        return false;
                    }
                }
                this.errors[target.name] = false;
                // this.changed[target.name] = true;
                return true;
            } else {
                this.createDialog({ "title": "Warning", "body": 'The Social Insurance Number entered is not valid. Please review and update.', "buttonNo": false, "buttonYesLabel": "OK" });
                this.errors[target.name] = true;
                return false;
            }
        } else {
            // not US and Canada
            this.employee[target.name] = target.value;
            this.errors[target.name] = false;
            // this.changed[target.name] = true;
            return true;
        }
    },

    checkI9Fields(i9Fields) {
        let type = ''
        let message = '';
        let fatalError = false;
        let status = false;

        if (i9Fields) {
            type = 'standalone';
        } else {
            i9Fields = this.assignment;
            type = 'employer';
        }

        // Check if List A or Lists B/C are complete.
        if (type === 'employer' || type === 'standalone') {
            if (! i9Fields.list_a_type_id && ! i9Fields.list_b_type_id && ! i9Fields.list_c_type_id) {
                message = 'Please complete List A <u>OR</u> Lists B & C fields and review the I-9 Verification before submitting.<br />';
            }

            if (i9Fields.list_a_type_id && (! i9Fields.list_a_number || ! i9Fields.list_a_exp )) {
                if (!i9Fields.list_a_number) this.errors.list_a_number = true;
                if (!i9Fields.list_a_exp) this.errors.list_a_exp = true;
                message = 'Please complete List A of I-9 Verification before submitting.<br />';
            }
            if ((i9Fields.list_b_type_id || i9Fields.list_c_type_id) && (! i9Fields.list_b_number || ! i9Fields.list_b_exp || ! i9Fields.list_c_number || ! i9Fields.list_c_exp)) {
                if (!i9Fields.list_b_type_id) this.errors.list_b_type_id = true;
                if (!i9Fields.list_c_type_id) this.errors.list_c_type_id = true;
                if (!i9Fields.list_b_number) this.errors.list_b_number = true;
                if (!i9Fields.list_c_number) this.errors.list_c_number = true;
                if (!i9Fields.list_b_exp) this.errors.list_b_exp = true;
                if (!i9Fields.list_c_exp) this.errors.list_c_exp = true;
                message = 'Please complete List B & C of I-9 Verification before submitting.<br />';
            }
        } else {
            if (i9Fields.ee_list_a_type_id && (! i9Fields.ee_list_a_number || ! i9Fields.ee_list_a_exp )) {
                if (!i9Fields.ee_list_a_number) this.errors.ee_list_a_number = true;
                if (!i9Fields.ee_list_a_exp) this.errors.ee_list_a_exp = true;
                message = 'Please complete List A of I-9 Verification before submitting.<br /><br />';
            }
            if ((i9Fields.ee_list_b_type_id || i9Fields.ee_list_c_type_id) && (! i9Fields.ee_list_b_number || ! i9Fields.ee_list_b_exp || ! i9Fields.ee_list_c_number || ! i9Fields.ee_list_c_exp)) {
                if (!i9Fields.ee_list_b_type_id) this.errors.ee_list_b_type_id = true;
                if (!i9Fields.ee_list_c_type_id) this.errors.ee_list_c_type_id = true;
                if (!i9Fields.ee_list_b_number) this.errors.ee_list_b_number = true;
                if (!i9Fields.ee_list_c_number) this.errors.ee_list_c_number = true;
                if (!i9Fields.ee_list_b_exp) this.errors.ee_list_b_exp = true;
                if (!i9Fields.ee_list_c_exp) this.errors.ee_list_c_exp = true;
                message = 'Please complete List B & C of I-9 Verification before submitting.<br /><br />';
            }

            // Prevent both sections from being completed
            if (i9Fields.ee_list_a_type_id && (i9Fields.ee_list_b_type_id || i9Fields.ee_list_c_type_id)) {
                message += 'On the I-9 section, you have entered both a List A document along with List B/C document(s).  Please clear either your List A information <u>OR</u> your List B and List C information.<br /><br />';
                fatalError = true;
            }
        }

        if (message) {
            // Failed I9
            return { status: status, message: message, fatal: fatalError };
        } else {
            // Passed
            status = true;
            return { status: status, message: message, fatal: fatalError };
        }
    },

    verifyI9(event) {
        // Check I9 if blank, and if not, then mark I9 as verified by putting userId into the assignment
        let verified = false;
        let message = '';
        let fatalError = false;
        let status = false;

        if (((this.assignment.loanout_status === true || parseInt(this.assignment.loanout_status) === 1) && this.enforceLoanoutI9 !== true) || (this.isForeign && !this.isSsnNeeded)) {
            status = true;
            return { status: status, message: message };
        }

        verified = this.i9_verified;

        if (verified) {
            const result = this.checkI9Fields();
            if (result.status === true) {
                status = true;
            } else {
                message = result.message;
                fatalError = result.fatal || false;
            }
        } else if (this.assignment.is_rehire) {
            const result = this.checkI9Fields();
            if (result.status === true) {
                status = true;
            } else {
                message = result.message;
                fatalError = result.fatal || false;
            }
        } else {
            message = 'You have not verified the I-9 by checking the box on the form.<br >';
        }

        if (message) {
            // Failed
            this.assignment.i9_verifier_id = null;
            return { status: status, message: message, fatal: fatalError };
        } else {
            // Passed
            status = true;
            if (! this.assignment.i9_verifier_id) this.assignment.i9_verifier_id = this.employer.id;
            return { status: status, message: message, fatal: fatalError };
        }
    },

    // to check valid date or not. ex) 2/30/2030 -> invalid.
    isValidDate(month, day, year) {
        month = month - 1;
        var d = new Date(year, month, day);
        if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
          return true;
        }
        return false;
    },

    verifyDate(target, type) {
        if (! target || typeof target.value === 'undefined' ) {
            return true;
        }
        let splitDate;

        // format that is from dateField is YYYY-MM-DD so need to match format MM/DD/YYYY and type change from dataField to expiration
        // It is simple way to work this existing function.
        if (type === 'expiration') {
            let digits = target.value.replace (/[^0-9]/g,'');
            let year = digits.substr(0,4);
            let month = digits.substr(4,2);
            let day = digits.substr(6,2);
            digits = month + '/' + day + '/' + year;
            splitDate = digits.split('/');
        } else {
            let temp = target.value.replace(/[ \.\,\/-]/g, '/').split('/');
            if (temp.length != 3 || !temp[0] || !temp[1] || !temp[2]) {
                this.errors[target.name] = true;
                return false;
            }
            // make MM/dd/yyyy format to make compatible with existing logic.
            if (this.format === 'yyyy/MM/dd') {
                temp = temp[1] + '/' + temp[2] + '/' + temp[0];
            } else if (this.format === 'dd/MM/yyyy') {
                temp = temp[1] + '/' + temp[0] + '/' + temp[2];
            } else {
                temp = temp.join('/');
            }
            splitDate = temp.split('/');
        }
        let finalDate = undefined;
        // Allow an override
        if (this.assignment.loanout_status > 0 && ( target.value == 0 || target.value.toLowerCase() === 'na' )) {
            this.employee[target.name] = 'NA';
            this.errors[target.name] = false;
            // if (this.changed) this.changed[target.name] = true;
            return true;
        } else if (splitDate[2].length == 2) {
            let year = parseInt (splitDate[2]);
            let fullYear = undefined;
            if (year > 0 && year <= 19) fullYear = '20' + year;
            else if (year >= 20 && type === 'birthdate') fullYear = '19' + year;
            else if (year >= 20 && type === 'expiration') fullYear = '20' + year;
            else fullYear = '20' + year;
            splitDate[2] = fullYear;
        }

        if (!this.isValidDate(splitDate[0], splitDate[1], splitDate[2])) {
            this.errors[target.name] = true;
            return false;
        }
        finalDate = new Date(splitDate.join('/'));

        let oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

        // Now check age
        if (type === 'birthdate' && finalDate >= new Date()) {
            // too young!
            // console.log ('Too Young');
            // this.changed[target.name] = false;
            this.errors[target.name] = true;
            return false;
        } else if (type === 'birthdate' && new Date() - finalDate > 3000000000000) {
            // too old!
            // console.log ('Too Old');
            // this.changed[target.name] = false;
            this.errors[target.name] = true;
            return false;
        } else if (type === 'birthdate') {
            // date is valid and good, I guess
            this.localFormatBirthDate = DateTime.fromJSDate(finalDate).toFormat(this.format);
            this.employee.birth_date = DateTime.fromJSDate(finalDate).toFormat(this.format);
            this.errors[target.name] = false;
            // this.changed[target.name] = true;
            return true;

        } else if (type === 'expiration' && (new Date() <= finalDate)) {
            // console.log ('Good ' + finalDate);
            this.errors[target.name] = false;
            // this.changed[target.name] = true;

            return true;

        } else if (type === 'expiration' && new Date() > finalDate) {
            // Expired
            // console.log ('Expired');
            // this.changed[target.name] = false;
            this.errors[target.name] = true;
            return false;
        } else if (type === 'certification' && finalDate > new Date()) {
            // Can't be future certified
            // console.log ('Cannot be future certified');
            this.errors[target.name] = true;
            return false;
        } else if (type === 'certification' && finalDate > oneYearAgo) {
            // console.log ('Good ' + finalDate);
            this.errors[target.name] = false;

            let fixedDate = DateTime.fromJSDate(finalDate).toFormat(this.format);
            this.localFormatCertificationDate = fixedDate;

            return true;
        } else {
            // console.log ('Not sure ' + finalDate);
            this.errors[target.name] = true;
            return false;
        } 
    },

    verifyBirthDate({ target }) {
        if (! this.verifyDate(target,'birthdate')) {
            $("input[name='birth_date']").addClass("form-error");
            return false;
        } else {
            $("input[name='birth_date']").removeClass("form-error");
            $("input[name='birth_date']").addClass("form-change");
            return true;
        }
    },

    // Can only be within last year
    verifyCertDate({ target }) {
        return this.verifyDate(target,'certification');
    },
  } 
}